/* GridTextEditor.js */

"use strict";
const _ = require("lodash");

class GridTextEditor {
    constructor(args) {
        this.parentContainer = args.container;
        this.column = args.column;
        this.initialValue = {};
        this.field = args.column.field;
        this.grid = args.grid;
        this.commitChanges = args.commitChanges;

        this.textInput = document.createElement("input");
        if (_.get(args.column, "fcdColumnDef.Display.password", false)) {
            this.textInput.setAttribute("type", "password");
        } else {
            this.textInput.setAttribute("type", "text");
        }
        this.textInput.classList.add("grid_text_editor");
        this.parentContainer[0].appendChild(this.textInput);
    }

    static Formatter(row, cell, value, column /*, dataContext*/) {
        let displayElem = document.createElement("div");

        let currentValue = _.isEmpty(value)
            ? ""
            : _.get(column, "fcdColumnDef.Display.password", false)
            ? value.replace(/./g, "&#9679;")
            : value;
        displayElem.innerHTML = currentValue;

        let displayinfo = column.fcdColumnDef.displayinfo;
        displayElem.setAttribute("title", displayinfo.tooltip);
        displayElem.classList.add("grid_cell_view");

        return displayElem.outerHTML;
    }

    _registerListeners() {
        this.textInput.addEventListener("click", (this._onClick = this._onClick.bind(this)));
        this.textInput.addEventListener("blur", (this._onBlur = this._onBlur.bind(this)));
    }

    _unregisterListeners() {
        this.textInput.removeEventListener("click", this._onClick);
        this.textInput.removeEventListener("blur", this._onBlur);
    }

    destroy() {
        this._unregisterListeners();
    }

    show() {
        this.textInput.focus();
    }

    hide() {}

    position(/*position*/) {}

    focus() {
        this.textInput.focus();
    }

    loadValue(item) {
        this.initialValue = item[this.field];
        this.textInput.value = item[this.field];
        this.textInput.select();
        this._registerListeners();
    }

    getValue() {
        return _.isEmpty(this.textInput.value) ? "" : this.textInput.value;
    }

    setValue(value) {
        this.textInput.value = value;
    }

    serializeValue() {
        return _.isEmpty(this.textInput.value) ? "" : this.textInput.value;
    }

    applyValue(item, state) {
        item[this.field] = state;
        this.initialValue = state;
    }

    isValueChanged() {
        return !_.isEqual(this.textInput.value, this.initialValue);
    }

    validate() {
        return {
            valid: true,
            msg: null,
        };
    }

    _valueChanged() {}

    _onClick(event) {
        event.stopImmediatePropagation();
    }

    _onBlur() {
        if (this.grid.getEditorLock().isActive() && this.isValueChanged()) {
            this.grid.getEditController().commitCurrentEdit();
        }
    }
}

module.exports = GridTextEditor;
